import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { FacitContainer } from './containers/container.facit.js';
import { InputContainer } from './containers/container.input.js';
import { jsx } from 'react/jsx-runtime';

function PlaceTransparentImagesOnImageTask(props) {
  const context = useTaskContext();
  const pageContext = usePageContext();
  if (context === "input" && pageContext !== "print") {
    return /*#__PURE__*/jsx(InputContainer, {
      ...props
    });
  } else {
    return /*#__PURE__*/jsx(FacitContainer, {
      ...props
    });
  }
}

export { PlaceTransparentImagesOnImageTask };
//# sourceMappingURL=_task.transparent-images-on-image.js.map
